export default "__VITE_ASSET__BJ71spU1__"